import { useState, useEffect } from 'react'
import AccountsBffClient from '../api/http/AccountsBffClientHttp'
import get from 'lodash/get'
import axios from 'axios'

const client = new AccountsBffClient(axios)

const useProfile = () => {
  const [loading, setLoading] = useState(true)
  const [userId, setUserId] = useState(null)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [managedBy, setManagedBy] = useState('')
  const [hierarchy, setHierarchy] = useState(null)
  const [linkedAccounts, setLinkedAccounts] = useState(
    null
  )
  const [children, setChildren] = useState([])
  const [groupMembershps, setGroupMemberships] = useState(null)
  const [scopes, setScopes] = useState([])  

  useEffect(() => {
    async function getProfile() {
      try {
        const response = await client.getMyProfile()
        const success = get(response, 'data.profile.success', false)
        const userid = get(response, 'data.profile.userId')
        const fname = get(response, 'data.profile.firstName')
        const lname = get(response, 'data.profile.lastName')
        const profileManagedBy = get(response, 'data.profile.managedBy')
        const userEmail = get(response, 'data.profile.email')
        const userAccounts = get(response, 'data.profile.linkedAccounts', [])
        const childrenList = get(response, 'data.profile.children', [])
        const hierarchyParams = get(response, 'data.profile.hierarchy', null)
        const memberships = get(
          response,
          'data.profile.academicGroupMemberships',
          []
        )   
        const userScopes = get(response, 'data.profile.scopes', [])     

        if (success) {
          setUserId(userid)
          setFirstName(fname)
          setLastName(lname)
          setEmail(userEmail)
          setLinkedAccounts(userAccounts)
          setChildren(childrenList || [])
          setManagedBy(profileManagedBy)
          setGroupMemberships(memberships)
          setHierarchy(hierarchyParams)
          setScopes(userScopes)
        }
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    }
    getProfile()
  }, [])

  return {
    loading,
    userId,
    firstName,
    lastName,
    managedBy,
    email,
    hierarchy,
    linkedAccounts,
    children,
    groupMembershps,
    setManagedBy,
    scopes
  }
}

export default useProfile



// WEBPACK FOOTER //
// ./src/shared/hooks/useProfile.js